import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const GtfsTestMonitoringApp = lazy(() => import('./GtfsTestMonitoringApp'));

const GtfsTestMonitoringAppConfig = {
    settings: {
        layout: {},
    },
    auth: authRoles.user,
    routes: [
        {
            path: 'apps/agency/gtfs/monitoring',
            element: <GtfsTestMonitoringApp />,
        }
    ],
};

export default GtfsTestMonitoringAppConfig;
